"use client";

import { Button, ButtonProps } from "@/components/ui/button";
import { LoaderCircle } from "lucide-react";
import React from "react";

interface Props extends ButtonProps {
  isPending: boolean;
}

export const LoadingButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ isPending, children, className, ...props }, ref) => {
    return (
      <Button disabled={isPending} {...props} ref={ref} className={className}>
        {isPending ? (
          <LoaderCircle className="h-4 w-4 animate-spin" />
        ) : (
          children
        )}
      </Button>
    );
  },
);

LoadingButton.displayName = "LoadingButton";
